import React from 'react';
import { Section } from './Section';
import { X } from 'lucide-react';
export function ProblemSection() {
  return <Section alternate id="problem" data-id="element-108">
      <h2 className="font-serif text-3xl md:text-4xl text-brown mb-8 text-center" data-id="element-109">
        This is for you if...
      </h2>

      <div className="space-y-6 mb-12" data-id="element-110">
        <p className="text-lg text-brown-light" data-id="element-111">
          You can’t even do the basics without bargaining with a nap. You’re
          holding a sleeping baby and thinking:
        </p>

        <ul className="grid gap-4" data-id="element-112">
          {['“I have to pee so bad.”', '“I’m starving.”', '“I should shower.”', '“I can’t move… again.”', '“I love them… why do I feel trapped?”'].map((thought, i) => <li key={i} className="flex items-center gap-4 bg-white p-4 rounded-xl shadow-sm" data-id="element-113">
              <X className="w-5 h-5 text-terracotta shrink-0" data-id="element-114" />
              <span className="font-medium text-brown italic" data-id="element-115">{thought}</span>
            </li>)}
        </ul>
      </div>

      <div className="bg-terracotta/10 p-6 md:p-8 rounded-2xl text-center" data-id="element-116">
        <p className="text-lg md:text-xl text-brown mb-4" data-id="element-117">
          And then the guilt hits. Because you <em data-id="element-118">are</em> grateful.
        </p>
        <p className="font-serif text-xl md:text-2xl text-terracotta font-medium" data-id="element-119">
          You just also have a nervous system and a body.
        </p>
      </div>

      <div className="mt-16" data-id="element-120">
        <h3 className="font-serif text-2xl md:text-3xl text-brown mb-6" data-id="element-121">
          Here’s the truth nobody says plainly
        </h3>
        <p className="text-lg text-brown-light mb-6" data-id="element-122">
          In weeks 6–12, many babies aren’t “bad sleepers.” They’re just wired
          to sleep best on a warm human.
        </p>
        <p className="text-lg text-brown-light font-medium" data-id="element-123">
          But you can’t build a life on “maybe I’ll get a break later.” So
          instead of chasing the perfect nap... we build a day structure that
          works even when naps don’t.
        </p>
      </div>
    </Section>;
}